import { getAccessToken } from '../../../selectors/doctorsPi/payments';
import { getDocumentIsApiPending, getDeclarationsIsApiPending } from '../../../selectors/doctorsPi/documents';
import { getCheckDocuments, getUploadDocumentsForm } from '../../../selectors/doctorsPi/documents';
import { getPersonalDetailsId } from '../../../selectors/doctorsPi/personalDetails';
import { apiTransitionDocumentsForm, apiTransitionDeclarationsForm } from '../../../actions/doctorsPi/documents';
import { setExpiredAuth } from '../../../actions/doctorsPi/quote';
import axios from 'axios';

export const payloadUploadDeclarationsService = (store, next, action) => {
    (async () => {
        if (!getDeclarationsIsApiPending(store.getState())) {
            store.dispatch(apiTransitionDeclarationsForm.pending());
            try {
                const resp = await calculate(store.getState());
                await calculateStatus(store.getState());
                
                if (resp.data) {
                    store.dispatch(apiTransitionDeclarationsForm.success());
                }
            } catch (e) {
                if (e?.response?.data?.status === 401 || e?.response?.data?.status === 403) {
                    store.dispatch(setExpiredAuth(true));
                } else {
                    store.dispatch(apiTransitionDeclarationsForm.failure());
                }
            }
        }
    })();

    return next(action);
};

const payloadCollection = (state) => {
    const statements = getCheckDocuments(state);
    const pid = getPersonalDetailsId(state);

    const declarations = [
        'Are you presently in any medical association or society of good standing?',
        'Are you in partnership or association with another practitioner/s?',
        'Do you own in whole or part any clinic, hospital or sanatorium or similar enterprise?',
        'Has any claims been made against you or your partners during the last 5 years?',
        'Is there any incident within your knowledge which my subsequently give rise to a claim against you for professional negligence?',
        'Has any application for insurance ever been declined by insurer, accepted subject to premium increase or accepted subject to special restrictions?',
    ];

    function generateDeclarationText(declarations, statements) {
        let textList = [];
        let declarationKeys = Object.keys(declarations);

        for (let i = 0; i < declarationKeys.length; i++) {
            let declarationKey = declarationKeys[i];
            let declarationValue = declarations[declarationKey].value;
            let statement = statements[i];
            if (declarationValue) {
                textList.push(`Yes - ${statement}`);
            } else {
                textList.push(`No - ${statement}`);
            }
        }

        return textList.join(', ');
    }

    // Generate the text
    const joinedText = generateDeclarationText(statements, declarations);

    const documentsPayload = {
        id: pid,
        declaration: joinedText || 'NA',
    };

    return {
        ...documentsPayload,
    };
};

const calculate = async (state) => {
    const loginData = getAccessToken(state);
    try {
        const url = '/om-api/doctors-pi/upload-declarations';

        return await axios.post(url, payloadCollection(state), {
            headers: {
                'Content-Type': 'application/json',
                accessToken: loginData.accessToken,
            },
        });
    } catch (e) {
        throw e;
    }
};


const payloadCollectionStatus = (state) => {
    const pid = getPersonalDetailsId(state);
    const documentsPayload = {
        customerId: pid,
    };

    return {
        ...documentsPayload,
    };
};


const calculateStatus = async (state) => {
    const loginData = getAccessToken(state);
    try {
        const url = '/om-api/doctors-pi/user-status';

        return await axios.post(url, payloadCollectionStatus(state), {
            headers: {
                'Content-Type': 'application/json',
                accessToken: loginData.accessToken,
            },
        });
    } catch (e) {
        throw e;
    }
};

// -------------------------------------------------------------------
export const payloadUploadDocumentsService = (store, next, action) => {
    (async () => {
        if (!getDocumentIsApiPending(store.getState())) {
            store.dispatch(apiTransitionDocumentsForm.pending());
            try {
                const resp = await calculateDocs(store.getState());
                if (resp.data) {
                    store.dispatch(apiTransitionDocumentsForm.success());
                }
            } catch (e) {
                if (e?.response?.data?.status === 401 || e?.response?.data?.status === 403) {
                    store.dispatch(setExpiredAuth(true));
                } else {
                    store.dispatch(apiTransitionDocumentsForm.failure());
                }
            }
        }
    })();

    return next(action);
};

const docsPayloadCollection = (state) => {
    const documents = getUploadDocumentsForm(state);
    const pid = getPersonalDetailsId(state);

    const documentsPayload = {
        id: pid,
        idNumberDoc: documents.nationalId.value.base64File || 'NA',
        currentLicenseDoc: documents.currentLicense.value.base64File || 'NA',
        resumeDoc: documents.resume.value.base64File || 'NA',
        academicCertificateDoc: documents.academicCertificates.value.base64File || 'NA',
        kraPinDoc: documents.kraPin.value.base64File || 'NA',
    };

    return {
        ...documentsPayload,
    };
};

const calculateDocs = async (state) => {
    const loginData = getAccessToken(state);
    try {
        const url = '/om-api/doctors-pi/upload-documents';

        return await axios.post(url, docsPayloadCollection(state), {
            headers: {
                'Content-Type': 'application/json',
                accessToken: loginData.accessToken,
            },
        });
    } catch (e) {
        throw e;
    }
};